import { Header } from './header';
import { HeaderCluster } from './header-cluster';
import { HeaderItem } from './header-item';

export class DevHeader implements Header {
  public name = '';
  public clusters: HeaderCluster[] = [];

  constructor(name: string, priceManager = false, operationalAccess = false, pimAccess = true) {
    this.name = name;

    const portfolioItems: HeaderItem[] = [
      {
        name: 'Parceiros',
        url: 'external/partners',
      },
      {
        name: 'Portfólio',
        url: 'portfolio',
      },
    ];
    // The role `dev` opens PIM at the pharmacy that holds it, which may not be one this app
    // offers (G7), so the link follows the pharmacies PIM is offered for.
    if (pimAccess) {
      portfolioItems.push({
        name: 'PIM',
        url: 'pim',
      });
    }
    if (priceManager) {
      portfolioItems.push({
        name: 'Preços',
        url: 'portfolio/precos',
      });
    }

    // The operational area is granted, not inferred from the role: `bidsweb:operational` on a
    // login-farmacias session, an internal address on a legacy one. It used to appear for anyone
    // holding the dev ANF, which is neither the same set nor the one the guard admits.
    const reportingItems: HeaderItem[] = [
      { name: 'Relatórios', url: 'reporting' },
      { name: 'Oportunidades', url: 'opportunities' },
      { name: 'Easy Gest', url: 'external/easygest' },
    ];
    if (operationalAccess) {
      reportingItems.push({ name: 'Portal Operacional', url: 'operational' });
    }

    this.clusters = [
      {
        items: [
          {
            name: 'Home',
            url: '',
          },
          {
            name: 'Contactos',
            url: 'external/contacts',
          },
          {
            name: 'Destaques',
            url: 'campaigns',
          },
        ],
      },
      {
        items: portfolioItems,
      },
      {
        items: [
          {
            name: 'Encomendas',
            url: 'orders',
          },
          {
            name: 'Campanhas',
            url: 'campanhas',
          },
          {
            name: 'Foco',
            url: 'foco',
          },
          // {
          //   name: 'Lançamentos',
          //   url: '',
          // },
        ],
      },
      {
        items: [
          // {
          //   name: 'Training Circle',
          //   url: 'external/training',
          // },
          // {
          //   name: '20 Minute Pitch',
          //   url: 'external/pitch',
          // },
          // {
          //   name: 'Tutoriais',
          //   url: 'external/tutorials',
          // },
          {
            name: 'Formação',
            url: 'external/training',
          },
        ],
      },
      {
        items: [
          {
            name: 'Montras Digitais',
            url: 'external/digital-display',
          },
          {
            name: 'Redes Sociais',
            url: 'external/social-networks',
          },
          {
            name: 'Expositores',
            url: 'external/exhibitors',
          },
          /*           {
            name: 'BClient',
            url: 'external/bclient',
          }, */
        ],
      },
      {
        items: reportingItems,
      },
    ];
  }
}
